import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AsistenciaMailComponent } from './asistencia-mail.component';
import { EFormComponent } from './component/eForm/eForm.component';
import { OnInit, OnDestroy } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { CarouselComponent } from '../asistencia-mail/component/carousel/carousel.component';
import { CarouselItemDirective } from '../asistencia-mail/component/carousel/carousel-item.directive';
import { CarouselItemElementDirective } from '../asistencia-mail/component/carousel/carousel-item-element.directive';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {MatRadioModule} from '@angular/material/radio';



@NgModule({
  imports: [
    CommonModule,
     FormsModule,
     MatButtonModule, 
     MatIconModule,
     BrowserModule,
     BrowserAnimationsModule,
     MatSlideToggleModule,
     MatCardModule,
     MatProgressSpinnerModule,
     MatExpansionModule,
     MatFormFieldModule,
     MatInputModule,
     MatRadioModule,
     MatSelectModule,
      
  ],
  declarations: [
    AsistenciaMailComponent,
    EFormComponent,
    CarouselComponent,
    CarouselItemDirective, 
    CarouselItemElementDirective
  ],
  exports: [
    AsistenciaMailComponent
 ],
 bootstrap: [
  AsistenciaMailComponent
]
})
export class AsistenciaMailModule  implements OnInit, OnDestroy { 

  ngOnInit() {
  }

  ngOnDestroy(){

  }


}